var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(" Bulk Tasks ")]),_c('v-card-text',[_vm._v(" Hello World "+_vm._s(_vm._f("incidentStatus")(_vm.status)))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }